import { CURRENCY_OPTIONS } from './countryDefaults';

export const TENANT_PLAN_BILLING_INTERVALS = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'yearly', label: 'Yearly' },
  { value: 'lifetime', label: 'Lifetime' },
] as const;

export type TenantPlanBillingInterval = typeof TENANT_PLAN_BILLING_INTERVALS[number]['value'];

export const TENANT_PLAN_CURRENCY_OPTIONS = CURRENCY_OPTIONS;

/** Max allowed plan price (inclusive). 0 = free / custom. */
export const TENANT_PLAN_PRICE_MIN = 0;
export const TENANT_PLAN_PRICE_MAX = 999_999;

/** Trial days: must be at least 1 (0 is not allowed). */
export const TENANT_PLAN_TRIAL_DAYS_MIN = 1;
export const TENANT_PLAN_TRIAL_DAYS_MAX = 365;

/** Max users: leave blank for unlimited. */
export const TENANT_PLAN_MAX_USERS_MIN = 1;
export const TENANT_PLAN_MAX_USERS_MAX = 99_999;

export const TENANT_PLAN_FORM_TABS = [
  { id: 'info', title: 'Plan info', subtitle: 'Code, name, and description' },
  { id: 'pricing', title: 'Pricing & limits', subtitle: 'Price, billing cycle, trial, and caps' },
  { id: 'modules', title: 'Highlights & publish', subtitle: 'Plan highlights and visibility' },
] as const;

export type TenantPlanFormTabId = typeof TENANT_PLAN_FORM_TABS[number]['id'];
